var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "container container--login" }, [
    _c(
      "h1",
      {
        staticClass: "login__header",
        class: _vm.$mq === "mobile" ? "h2" : "h4",
      },
      [_vm._v("Sign Up")]
    ),
    _c("div", { ref: "formWrapper", staticClass: "login__main" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "small-12 medium-5 column" }, [
          _c("div", { staticClass: "login__column" }, [_vm._t("default")], 2),
        ]),
        _vm._m(0),
        _vm._m(1),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "small-12 medium-2 column login__divider" },
      [_c("div", { staticClass: "login__divider__line" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "small-12 medium-5 column login__alt-container" },
      [
        _c("div", { staticClass: "login__column" }, [
          _c("div", { staticClass: "oxi-social-login" }),
          _c("div", { staticClass: "login__button login__button--register" }, [
            _c("p", { staticClass: "login__button-label" }, [
              _vm._v("Already Have an Account?"),
            ]),
            _c(
              "a",
              {
                staticClass: "u-link u-link--bold",
                attrs: { href: "/account/login" },
              },
              [_vm._v("Log In")]
            ),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }